module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames4-af524319aabf91d33ed3b9e1ddebcf0f.webp";